var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroOwnership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 7.50056C6.25 5.14399 8.14337 3.25098 10.5 3.25098C12.8566 3.25098 14.75 5.14399 14.75 7.50056C14.75 9.85785 12.8568 11.751 10.5 11.751C8.14325 11.751 6.25 9.85785 6.25 7.50056Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 18.3618C3.25 15.5386 5.53862 13.25 8.36177 13.25H12.6382C15.4614 13.25 17.75 15.5386 17.75 18.3618V19C17.75 19.4142 17.4142 19.75 17 19.75H4C3.58579 19.75 3.25 19.4142 3.25 19V18.3618Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1503 10.1288V7.87891H18.6503V10.1288L16.4004 10.1288V11.6288L18.6503 11.6288V13.8789H20.1503V11.6288L22.4004 11.6288V10.1288L20.1503 10.1288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroOwnership);
export default __webpack_public_path__ + "static/media/hero-ownership.a0551ec8413b1da958778d9c6272108e.svg";
export { ForwardRef as ReactComponent };